import { Fingerprint, FingerprintContextInterface } from '@fingerprint/react'
import { FAILED_FINGERPRINT_ID } from './constants'

// Share one client between React hooks and the existing authentication API helpers.
// Initialize at module scope, outside React's render/effect lifecycle.
function startFingerprint() {
  if (typeof window === 'undefined' || !process.env.REACT_APP_FP_API_KEY) return

  try {
    return Fingerprint.start({
      apiKey: process.env.REACT_APP_FP_API_KEY,
      region: 'us',
      endpoints: process.env.REACT_APP_FP_ENDPOINT || undefined
    })
  } catch (error) {
    console.info('Unable to initialize Fingerprint:', error)
  }
}

const fingerprint = startFingerprint()

export const fingerprintContext: FingerprintContextInterface = {
  getVisitorData: async options => {
    if (!fingerprint) throw new Error('Fingerprint is not configured')
    return fingerprint.get(options)
  }
}

export async function getFPVisitorId(options?: Fingerprint.GetOptions): Promise<string> {
  try {
    const result = await fingerprintContext.getVisitorData(options)
    if (!result.visitor_id) return FAILED_FINGERPRINT_ID
    if (process.env.NODE_ENV === 'development') {
      console.info('Fingerprint visitor_id:', result.visitor_id, 'event_id:', result.event_id)
    }
    return result.visitor_id
  } catch (error) {
    console.info('Не удалось получить FPVisitorId:', error)
    return FAILED_FINGERPRINT_ID
  }
}
